import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import withWidth from '@material-ui/core/withWidth';
import MenuIcon from '@material-ui/icons/Menu';
import logo from 'img/logo_main.png';
import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import HeaderAuthHandler from './ProfileAvatar';
import { Toolbar } from '@material-ui/core';
import { authRef, sendEmailAddressVerification } from 'api';
import { useSelector } from 'react-redux';

function Header({ history, onMenuTapped }) {
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(false);
  const authUser = useSelector(state => state.authState.firestoreUser);

  useEffect(() => {
    if (!authUser.anon && !authRef.currentUser.emailVerified) {
      setOpen(true);
    } else {
      setOpen(false);
    }
    // eslint-disable-next-line
  }, []);

  const handleOnClick = () => {
    sendEmailAddressVerification();
    setOpen(false);
    setSent(true);
  };

  return (
    <>
      <Appbar>
        <ToolbarBar>
          <Hidden mdUp>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Menu"
              onClick={onMenuTapped}
            >
              <MenuIcon />
            </IconButton>
          </Hidden>

          <Title>
            <Link to="/" style={{ display: 'flex' }}>
              <Image src={logo} alt="Logo" />
            </Link>
          </Title>

          <Hidden smDown>
            <ToolbarLink to="/">Home</ToolbarLink>
            <ToolbarLink to="/exams">Exams</ToolbarLink>
            <ToolbarLink to="/result">Result</ToolbarLink>
            <ToolbarLink to="/forum">Forum</ToolbarLink>
          </Hidden>

          <HeaderAuthHandler history={history} />
        </ToolbarBar>

        {open && <ShowTopBar onClick={handleOnClick} />}
        {sent && (
          <ShowVerificationSentTopBar
            authUser={authUser}
            onClick={handleOnClick}
          />
        )}
      </Appbar>

      {!open && !sent ? (
        <Placeholder height="68px" />
      ) : (
        <Placeholder height="100px" />
      )}
    </>
  );
}

const ShowTopBar = props => {
  return (
    <Bar>
      <span style={{ textTransform: 'none' }}>Email not verified.</span>
      <span
        style={{
          textDecoration: 'underline',
          marginLeft: '5px',
          cursor: 'pointer',
          textTransform: 'none'
        }}
        onClick={props.onClick}
      >
        Click here to verfiy
      </span>
    </Bar>
  );
};

const ShowVerificationSentTopBar = props => {
  return (
    <Bar>
      <span style={{ textTransform: 'none' }}>
        Email sent to: {props.authUser.email}.
      </span>
      <span
        onClick={props.onClick}
        style={{
          fontStyle: 'italic',
          textDecoration: 'underline',
          cursor: 'pointer',
          marginLeft: '3px'
        }}
      >
        Try again
      </span>
    </Bar>
  );
};

const Bar = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.palette.primary['100']};
  color: ${props => props.theme.palette.primary['900']};
  padding: 2px;
  margin-top: 5px;

  @media (max-width: 600px) {
    margin-top: 13px;
  }
`;

const Appbar = styled(AppBar)`
  && {
    height: 68px;
    display: flex;
    justify-content: flex-start;
    border-bottom: 6px solid ${props => props.theme.palette.primary['900']};
    background-color: white;
    color: ${props => props.theme.palette.primary['500']};
    font-size: 16px;
    text-transform: capitalize;
    outline: none;
  }
`;

const Image = styled.img`
  height: 45px;
  width: auto;
`;

const Title = styled.div`
  display: flex;
  flex-grow: 1;
`;

const ToolbarLink = styled(Link)`
  text-decoration: none;
  display: inline-block;
  color: ${props => props.theme.palette.primary['500']};
  font-size: 16px;
  text-transform: capitalize;
  outline: none;
  font-weight: 900;
  padding: 0 8px 0px 8px;
  margin-right: 8px;
`;

const Placeholder = styled.div`
  height: ${props => props.height};
  flex: none;
`;

const ToolbarBar = styled(Toolbar)`
  width: 75%;
  margin-left: 12%;
  @media (max-width: 600px) {
    margin: 0px;
    width: 100%;
  }
`;

export default withRouter(withWidth()(Header));
